module.exports = __webpack_public_path__ + "static/media/pencil-alt.c18c45bf.svg";